import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ASSETS } from "@/lib/content";
import ProductCard from "@/components/ProductCard";
import MoonDivider from "@/components/MoonDivider";
import { MoonMark as Moon } from "@/components/MoonMark";

export default function Gifts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products", { params: { gifts: true } })
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="gifts-page">
      <section className="relative h-[46vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#17120d] via-[#0A0A0A] to-black" />
        <img src={ASSETS.moon} alt="" className="absolute right-4 bottom-0 h-[95%] w-auto object-contain object-bottom opacity-35 hidden md:block" />
        <div className="absolute inset-0 bg-black/70" />
        <div className="relative text-center px-6">
          <Moon className="w-8 h-8 text-gold mx-auto mb-5" strokeWidth={1.2} />
          <p className="font-body uppercase tracking-[0.35em] text-xs text-gold mb-3">Give In To Temptation</p>
          <h1 className="font-serif text-5xl sm:text-6xl text-cream">Gifts & Indulgences</h1>
          <p className="font-body text-white/60 mt-4 max-w-lg mx-auto">
            Discreetly wrapped, exquisitely presented. The perfect way to spoil someone you desire.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-16">
        <MoonDivider label="Gift-Ready Collections" />
        {loading ? (
          <p className="text-center font-serif text-xl text-white/40 py-16 mt-8">Wrapping something special…</p>
        ) : products.length === 0 ? (
          <p className="text-center font-serif text-xl text-white/40 py-16 mt-8" data-testid="no-gifts">No gifts available yet.</p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-8 mt-10">
            {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </section>
    </div>
  );
}
